import Editor, { loader } from '@monaco-editor/react';
import { useMemo } from 'react';

type JsonEditorProps = {
  value: string;
  onChange: (value: string) => void;
  height?: string | number;
  readOnly?: boolean;
};

export const JsonEditor: React.FC<JsonEditorProps> = ({
  value,
  onChange,
  height = 320,
  readOnly = false,
}) => {
  // Ensure Monaco loads from a local path instead of a CDN (offline-safe)
  loader.config({ paths: { vs: '/monaco/vs' } });
  const editorOptions = useMemo(
    () => ({
      minimap: { enabled: false },
      readOnly,
      lineNumbers: 'on' as const,
      fontSize: 14,
      scrollBeyondLastLine: false,
      automaticLayout: true,
    }),
    [readOnly],
  );

  return (
    <Editor
      height={typeof height === 'number' ? `${height}px` : height}
      defaultLanguage="json"
      value={value}
      theme="vs-light"
      options={editorOptions}
      onChange={(nextValue) => onChange(nextValue ?? '')}
    />
  );
};

export default JsonEditor;
